module.exports = __webpack_public_path__ + "img/mony2.06c24ff9.png";